import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GetCurrencySymbol } from '../../../../../../utils/Currency';
import { GetFloatNumber } from '../../../../../../utils/NumberFormatter';
import { EyeIcon } from '../../../../../../utils/SVGIcon';
import { GetDate } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function CustomerPaymentTr({ item }) {
    const navigate = useNavigate();
    const handleViewInvoice = () =>
        navigate(mkRelativeUrl(`/billing/invoices/${item?.invoiceId}/info`));
    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td onClick={() => handleViewInvoice()}>
                <span className="group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer">
                    {item?.invoiceId}
                </span>
            </td>
            <td>
                <span className="capitalize">{item?.method}</span>
            </td>
            {/* <td
                onClick={() => navigate(mkRelativeUrl(`/customers/${item?.userId}/payments`))}
                className="group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer"
            >
                <span>{item?.organization || '-----'}</span>
            </td> */}
            <td className="text-center  hidden xl:table-cell">
                <span>{GetDate(item?.timeInitiate) || 'No Initiate Date'}</span>
            </td>
            <td className="text-center  hidden xl:table-cell">
                <span>{GetDate(item?.timeSuccess) || 'No Success Date'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeFailed) || 'No Failed Date'}</span>
            </td>
            <td className="text-center">
                <span>{item?.currency}</span>
            </td>
            <td className="text-center">
                <span>
                    {GetCurrencySymbol(item?.currency)}
                    {GetFloatNumber(item?.amount || 0)}
                </span>
            </td>
            <td className="text-center">
                <span
                    className={cn('capitalize text-success', {
                        'text-warning': item?.status !== 'paid'
                    })}
                >
                    {item?.status}
                </span>
            </td>
            <td>
                <span>
                    <button
                        type="button"
                        onClick={() => handleViewInvoice()}
                        data-tooltip-id="myToolTip"
                        data-tooltip-content="View Invoice"
                        className="size-[31px] p-[5px] rounded-[7px] text-secondary-700 hover:text-secondary"
                    >
                        <EyeIcon />
                    </button>
                </span>
            </td>
        </tr>
    );
}

function CustomerPaymentTableHeader() {
    return (
        <thead>
            <tr className="*:!cursor-default">
                <th scope="col">
                    <span>ID</span>
                </th>
                <th scope="col" className="w-30">
                    <span>Invoice ID</span>
                </th>
                <th scope="col">
                    <span>Method</span>
                </th>
                {/* <th scope="col">
                    <span>Customer Info</span>
                </th> */}
                <th scope="col" className="w-30 text-center">
                    <span>Initiate Date</span>
                </th>
                <th scope="col" className="w-30 text-center hidden xl:table-cell">
                    <span>Success Date</span>
                </th>
                <th scope="col" className="w-30 text-center hidden xl:table-cell">
                    <span>Failed Date</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Currency</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Amount</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Status</span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}
function TableWeb({ data }) {
    return (
        <div className="subscription_payments_table mb-52">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <CustomerPaymentTableHeader />
                <tbody>
                    {data && data?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={10} className="!text-left">
                                No Payment Found!
                            </td>
                        </tr>
                    ) : (
                        data?.map((item) => <CustomerPaymentTr key={item.id} item={item} />)
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
